import _get from "lodash.get";

const isRedirectToLock = user => _get(user, "isLocked");

export default isRedirectToLock;
